import api from './api';

export const getOutlookStatus = async () => {
  const response = await api.get('/oauth/microsoft/status');
  return response.data;
};

export const getOutlookAuthorizeUrl = async () => {
  const response = await api.get('/oauth/microsoft/authorize');
  return response.data;
};

export const disconnectOutlook = async (email) => {
  const response = await api.delete(`/oauth/microsoft/disconnect?email=${encodeURIComponent(email)}`);
  return response.data;
};

export const downloadOutlookAttachment = async (attachmentId, filename, userEmail) => {
  const response = await api.post('/outlook/download-attachment', {
    attachment_id: attachmentId,
    filename: filename,
    user_email: userEmail,
  }, {
    responseType: 'blob',
  });

  return new File([response.data], filename, {
    type: response.data.type || 'application/pdf',
  });
};
